import axios from '@_system/axios/axios.js'
export default {
	path: '/group',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getstaff(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getstaff/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getdinggroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getdinggroup', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	createdinggroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createdinggroup', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	updatedinggroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatedinggroup', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/'+window.config.app+'/system.group', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
}
